<template>
	<b-modal ref="modal" hide-footer>
		<template v-slot:modal-title>
			{{ $t('invoice.supplier_article_rename_title') }}
		</template>

		<p class="text-muted">{{ $t('invoice.supplier_article_rename_help') }}</p>

		<form @submit.prevent="rename">
			<div class="form-group">
				<label for="article_rename_label">{{ $t('invoice.supplier_article_rename_label') }}</label>
				<b-input id="article_rename_label" v-model="label" autofocus />
			</div>

			<div class="text-center">
				<button type="submit" class="btn btn-primary" :disabled="!label.trim() || label.trim() === previous || processing">
					<font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse />
					{{ $t('invoice.supplier_article_rename_submit') }}
				</button>
			</div>
		</form>
	</b-modal>
</template>

<script type="text/javascript">
	import Invoice from "@/mixins/Invoice.js"

	export default {
		name: "ArticleRenameModal",
		mixins: [Invoice],
		data() {
			return {
				tiers_id: null,
				isarticles_id: null,
				previous: '',
				label: '',
				processing: false
			}
		},
		methods: {
			/**
			 * Ouvre la modale sur le nom actuel de l'article.
			 *
			 * @param {Object} article Article du tableau des articles achetés.
			 * @param {Number} tiers_id Fournisseur de l'article.
			 */
			open(article, tiers_id) {
				this.tiers_id = tiers_id
				this.isarticles_id = article.isarticles_id
				this.previous = article.isarticles_label
				this.label = article.isarticles_label
				this.processing = false
				this.$refs.modal.show()
			},

			/**
			 * Renomme l'article, puis prévient l'onglet que sa liste a changé : un nom déjà porté par un
			 * autre article l'y a rangé, et il a disparu de la liste.
			 */
			async rename() {
				this.processing = true

				if(await this.renameTiersSupplierArticle(this.tiers_id, this.isarticles_id, this.label.trim())) {
					this.$refs.modal.hide()
					this.$emit('updated')
				}

				this.processing = false
			}
		}
	}
</script>
